<div class="bottomSheetContainer" >
  <div class="header" (click)="dimiss()">
    <span>Selecciona un tipo de Jugada</span>
    <button><img src="assets/images/icons/danger.svg"></button>
  </div>
  <div class="betTypeList">
    @for (betType of combinaciones; track betType; let i = $index) {
      <div class="betTypeItem">
        <span class="label">{{i === 0 ? 'Sencilla' : 'Multiple'}}</span>
        <span class="price">{{betType.combinaciones * betType.precio * (betType.precio < 1 && i === 0 ? 2 : 1) |
        currency:'EUR'}}</span>
        <button (click)="selectBetType(betType)">{{betType.numeros}} num@if (betType.estrellas > 1) {
          <span> +
          {{betType.estrellas}}⭑</span>
        }</button>
      </div>
    }
  </div>
</div>